export default {
	init() {
		[...this.$el.querySelectorAll('.post')].forEach(post => {
			post.setAttribute('tabindex', 0);
		});

		const postContainer = [...this.$el.querySelectorAll('.post__container')];
		// if intersection observer is supported, wait for images to come close before loading them
		postContainer.forEach(container => {
			/* eslint-disable no-nested-ternary */
			container.setAttribute(
				'contains',
				container.childNodes.length > 1 ? 'multi' : container.childNodes.length > 0 ? 'single' : 'none'
			);
		});
	},
	destroy() {},
};
